<main
  class="login-page-wrapper"
>
  <section
    class="branding-panel"
  >
    <a
      class="branding-logo-tile"
      routerLink="/login"
    >
      <img
        class="branding-logo-img"
        src="assets/logos/pi-signage-full-logo.svg"
        alt="PI Signage"
      >
    </a>
    <div
      class="branding-content"
    >
      <p
        class="branding-tag"
      >
        Account recovery
      </p>
      <h1
        class="branding-heading"
      >
        Recover access securely.
      </h1>
      <p
        class="branding-subtext"
      >
        Request a time-limited password reset link for your organization account.
      </p>
    </div>
  </section>

  <section
    class="login-panel"
  >
    <div
      class="login-card"
    >
      <span
        class="login-welcome"
      >
        Account recovery
      </span>
      <h2
        class="login-title"
      >
        Reset your password
      </h2>
      <p
        class="login-description"
      >
        We will send a secure link if the account exists.
      </p>

      <form
        #forgotForm="ngForm"
        (ngSubmit)="onSubmit()"
      >
        <div
          class="login-field-group"
        >
          <label
            for="forgotEmail"
          >
            Email
          </label>
          <input
            pInputText
            class="login-input"
            id="forgotEmail"
            name="email"
            type="email"
            autocomplete="email"
            [(ngModel)]="email"
            required
          >
        </div>

        <p
          *ngIf="successMessage"
          class="alert success"
          role="status"
        >
          {{ successMessage }}
        </p>
        <p
          *ngIf="errorMessage"
          class="alert error"
          role="alert"
        >
          {{ errorMessage }}
        </p>

        <button
          class="login-btn login-btn-primary"
          type="submit"
          [disabled]="forgotForm.invalid || isSubmitting"
        >
          {{ isSubmitting ? 'Sending…' : 'Send reset link' }}
        </button>
      </form>

      <div
        class="auth-links single"
      >
        <a
          routerLink="/login"
        >
          Back to sign in
        </a>
      </div>
    </div>
  </section>
</main>
